import { useMutation } from '@apollo/client';
import { t } from '@lingui/core/macro';
import { useToast } from '@pocketlaw/tetris';
import { useUnmount } from 'react-use';
import { DocumentMetadataBulkSetPairsOperationType } from 'shared/domains/apollo/generated/types';
import { useAccount } from 'shared/domains/users';
import { BulkUpdateMetadataPropertyDocument } from './useBulkUpdateMetadataProperty.gql';
import { usePollBulkMetadataProperty } from './usePollBulkMetadataProperty';
export const useBulkUpdateMetadataProperty = () => {
    const { data: accountData } = useAccount();
    const { company } = accountData;
    const { addToast } = useToast();
    const { pollingState, startPolling, stopPolling } = usePollBulkMetadataProperty();
    const [mutation, state] = useMutation(BulkUpdateMetadataPropertyDocument);
    useUnmount(() => {
        stopPolling();
    });
    const setMetadataProperty = (options) => {
        const { documentIds, property, value } = options;
        const { label: propertyLabel } = property;
        return mutation({
            variables: {
                input: {
                    operationType: DocumentMetadataBulkSetPairsOperationType.Set,
                    companyId: company.id,
                    properties: [{ propertyName: property.name, value }],
                    documentIds,
                },
            },
            onCompleted() {
                startPolling({ documentIds, property, value, type: 'update' });
            },
            onError() {
                addToast({
                    appearance: 'danger',
                    title: t({
                        message: `Failed to update ${propertyLabel}`,
                        comment: 'Bulk action: Metadata - Error toast title',
                    }),
                });
            },
        });
    };
    const clearMetadataProperty = (options) => {
        const { documentIds, property } = options;
        const { label: propertyLabel } = property;
        return mutation({
            variables: {
                input: {
                    operationType: DocumentMetadataBulkSetPairsOperationType.Clear,
                    companyId: company.id,
                    properties: [{ propertyName: property.name }],
                    documentIds,
                },
            },
            onCompleted() {
                startPolling({ documentIds, property, value: null, type: 'clear' });
            },
            onError() {
                addToast({
                    appearance: 'danger',
                    title: t({
                        message: `Failed to clear ${propertyLabel}`,
                        comment: 'Bulk action: Metadata - Error toast title',
                    }),
                });
            },
        });
    };
    return Object.assign({ pollingState,
        setMetadataProperty,
        clearMetadataProperty }, state);
};
